import styles from "./SettingsTopMenu.module.scss";
import React from "react";
import {rxToggleMobileMenu, settingsSelector} from "../../slices/settingsSlice";
import {HeaderMenu} from "../../common/HeaderMenu";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

export const SettingsTopMenu = ({title, children}) => {
  const {t} = useTranslation("settings");

  const settings = useSelector(settingsSelector);

  const dispatch = useDispatch();

  return <>
    <div className={styles.menuMobile}>
      <HeaderMenu
        title={t(title)}
        onTitleClick={() => dispatch(rxToggleMobileMenu())}
        endIcon={
          <span className="material-icons">{settings.mobileMenuShown ? "arrow_drop_up" : "arrow_drop_down"}</span>
        }
      >
        {children}
      </HeaderMenu>
    </div>
    <div className={styles.menuDesktop}>
      <HeaderMenu title={t(title)}>{children}</HeaderMenu>
    </div>
  </>;
};
